<fieldset class="p-24:b md:p-32:b lg:p-48:b">
    <legend class="fw:bold m-16:b">Wähle den Abrechnungszeitraum:</legend>
    <div>
        <input
            type="radio"
            id="radio-payment-rhythm-monthly"
            name="payment-rhythm"
            value="monthly"
            [checked]="hasMonthlySettlementPeriod()"
            (change)="toggleSettlementPeriod(true)"
        />
        <label for="radio-payment-rhythm-monthly">monatlich</label>
        <input
            type="radio"
            id="radio-payment-rhythm-yearly"
            name="payment-rhythm"
            value="yearly"
            [checked]="!hasMonthlySettlementPeriod()"
            (change)="toggleSettlementPeriod(false)"
        />
        <label for="radio-payment-rhythm-yearly">jährlich</label>
    </div>
</fieldset>
